export const isDigitalCategory = ({ groupType }: { groupType: SpApi.PriceSheetGroupType }) =>
    groupType === 'digitals';

export const isFramedCategory = ({ groupType }: { groupType: SpApi.PriceSheetGroupType }) =>
    groupType === 'framed-prints' || groupType === 'matted-framed-prints';

export const isCustomCategory = (category: SpApi.IPriceSheetGroup) =>
    category.groupType === 'custom';
